import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { QA_MENU, QA_REVIEW } from 'constants/controllers'
import { URL_PDF_QA } from 'constants/urls'
import Header from './Header'
import Main from './Main'
import Right from './Right'

export default new Controller({
  name: QA_REVIEW,
  route: 'qareview/:aol/:flavour/:sectionId/:selectedIds',
  controller (
    Router,
    {
      url: pageId,
      scrollMain,
      query: { short },
      params: { flavour, sectionId, selectedIds, aol }
    },
    render
  ) {
    render(
      { Header, Main, Right },
      {
        aol,
        flavour,
        sectionId,
        selectedIds: selectedIds.split(','),
        pdfUrl: URL_PDF_QA,
        short,
        returnUrl: getUrl(QA_MENU, { flavour }),
        type: 'qa'
      },
      {
        aol,
        bottleLink: flavour => getUrl(QA_MENU, { flavour }),
        className: 'flavoured content-review',
        flavour,
        pageId,
        searchType: 'qa'
      }
    )

    return pageId
  }
})
